import { render, staticRenderFns } from "./PendingPinRegistrationApprovals.vue?vue&type=template&id=687736e8&"
import script from "./PendingPinRegistrationApprovals.vue?vue&type=script&lang=js&"
export * from "./PendingPinRegistrationApprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports